'use strict';

require('../users/CompanyUserService.js');
require('../groups/CompanyGroupService.js');
require('../groups/CompanyGroupUserService.js');
require('../groups/CompanyGroupPublicationService.js');
require('../publications/CompanyPublicationService.js');
require('../publications/PublicationTypeaheadDirective.js');
require('../users/CompanyUsersTypeahead.js');
require('../publications/CompanyPublicationMassEditCtrl.js');

var LIMIT = 100;

function CompanyCustomerPortalsDetailCtrl(
  $scope,
  customerPortal,
  publications,
  members,
  translations,
  $state,
  $stateParams,
  $sce,
  $filter,
  $modal,
  CompanyGroupService,
  CompanyGroupUserService,
  CompanyGroupPublicationService,
  CompanyPublicationService,
  CompanyService,
  growl,
  priorities
) {

  $scope.customerPortal = customerPortal;
  $scope.publications = publications;
  $scope.members = members;
  $scope.forms = {};
  $scope.newPublication = {};
  if($stateParams.priorityId){
    $scope.selectedPriority = priorities.find(function(p){
      return p.id === $stateParams.priorityId
    });
  }
  $scope.selectedYear = $stateParams.year || "";
  $scope.selectedMonth = $stateParams.month || "";
  $scope.years = [];
  for(var y=2010; y<2030; y++){
    $scope.years.push(y.toString())
  }

  $scope.months = [];
  for(var m=1; m<12; m++){
    $scope.months.push(m.toString())
  }

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml('customer-portals.documents'),
      'content': '',
      'template': 'partials/company/customer-portals/detail/documents.html',
      'icon': 'file-o'
    },
    {
      'title': $sce.trustAsHtml('customer-portals.info'),
      'content': '',
      'template': 'partials/company/customer-portals/detail/info.html',
      'icon': 'info-circle'
    }
  ];

  $scope.tabs.push(
    {
      'title': $sce.trustAsHtml('customer-portals.members'),
      'content': '',
      'template': 'partials/company/customer-portals/detail/members.html',
      'icon': 'users'
    }
  );

  $scope.tabs.activeTab = 0;
  $scope.priorities  = priorities;

  $scope.save = function() {
    CompanyGroupService.update({companyId: $stateParams.companyId, groupId: $scope.customerPortal.id}, $scope.customerPortal, function() {
      angular.element('#filterRole').val('');
      growl.addSuccessMessage(translations['customer-portals.saved-success']);
    }, function() {
      growl.addErrorMessage(translations['customer-portals.saved-failure']);
    });
  };

  $scope.delete = function(id) {
    CompanyGroupService.delete({companyId: $stateParams.companyId, groupId: id}, function() {
      growl.addSuccessMessage(translations['customer-portals.removed-success']);
      $state.go('root.company.customerPortals.list');
    }, function() {
      growl.addErrorMessage(translations['customer-portals.removed-failure']);
    });
  };


  $scope.removeMember = function(userId) {
    CompanyGroupUserService.delete({companyId: $stateParams.companyId, groupId: $stateParams.customerPortalId, userId: userId}, function() {
      $scope.members = $scope.members.filter(function(item) {
        return item.id !== userId;
      });

      growl.addSuccessMessage(translations['customer-portals.remove-member-success']);
    }, function() {
      growl.addErrorMessage(translations['customer-portals.remove-member-failure']);
    });
  };

  $scope.removePublication = function(publication) {
    if (publication.groups.indexOf($scope.customerPortal.id) > -1) {
      publication.groups.splice(publication.groups.indexOf($scope.customerPortal.id), 1);
    }
    CompanyPublicationService.update({companyId: $stateParams.companyId, publicationId: publication.id}, publication, function() {
      growl.addSuccessMessage(translations['customer-portals.remove-publication-success']);
      $scope.publications.splice($scope.publications.indexOf(publication), 1);
    }, function() {
      growl.addErrorMessage(translations['customer-portals.remove-publication-failure']);
    });
  };

  $scope.guestViews = [
    {
      "label": translations['customer-portal.template.default'],
      "value": "DEFAULT"
    },
    {
      "label": translations['customer-portal.template.my-page'],
      "value": "MYPAGE"
    }
  ];
  $scope.selectedView = $filter('filter')($scope.guestViews, {value: customerPortal.view})[0];

  $scope.inputTags = angular.copy($scope.customerPortal.tags);
  $scope.convertTags = function() {
    var newTags = [];
    newTags = $scope.inputTags.map(function(tag) { return tag.text; });
    angular.copy(newTags, $scope.customerPortal.tags);
  };

  $scope.loadTags = function() {
    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
  };

  $scope.setGroupCategory = function(category) {
    if (!category) {
      $scope.customerPortal.category = null;
    } else {
      $scope.customerPortal.category = category;
    }
  };

  $scope.setPriority = function(publication, priority) {
    var indexPublication = $scope.publications.indexOf(publication);
    if( ! priority) {
      $scope.publications[indexPublication].priority = null;
    } else {
      $scope.publications[indexPublication].priority = priority;
    }

    return $scope.savePublication($scope.publications[indexPublication]);
  };

  $scope.prioritiesSorted = ($filter('orderBy')($scope.priorities, 'stepNr')).filter(function(v){
    return v.stepNr > 0;
  });

  $scope.nextStatus = function(publication) {
    var indexPublication = $scope.publications.indexOf(publication);
    if ($scope.prioritiesSorted.length === 0) {
      return;
    }
    if (!$scope.publications[indexPublication].priority) {
      $scope.publications[indexPublication].priority = $scope.prioritiesSorted[0];
      $scope.savePublication($scope.publications[indexPublication]);
    } else {
      var index = $scope.prioritiesSorted.findIndex(function(v){
        return v.id === $scope.publications[indexPublication].priority.id;
      });

      if (index >= ($scope.prioritiesSorted.length - 1) || index < 0) {
        return;
      }

      $scope.publications[indexPublication].priority = $scope.prioritiesSorted[index + 1];
      $scope.savePublication($scope.publications[indexPublication]);
    }
  };

  $scope.publicationsMassEdit = [];
  $scope.namePublications = [];
  $scope.addPublicationsMassEdit = function(publication, publicationSelected){
    if(publicationSelected){
      $scope.publicationsMassEdit.push(publication.id);
      $scope.namePublications.push(publication);
    }else{
      $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
      $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
    }
  };

  $scope.selectAllPublication = function(){
    $scope.selectAll = !$scope.selectAll;
    angular.forEach($scope.publications, function(publication){
      if($scope.selectAll){
        publication.selected = true;
        $scope.publicationsMassEdit.push(publication.id);
        $scope.namePublications.push(publication);
      }else{
        publication.selected = false;
        $scope.publicationsMassEdit = [];
        $scope.namePublications = [];
      }
    });
  };

  $scope.showModalMassEdit = function() {
    $modal({
      scope: $scope,
      controller: 'CompanyPublicationMassEditCtrl',
      templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
      show: true,
      resolve: {
        priorities: function() {
          return priorities;
        },
        groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
          return CompanyGroupService.query({
            companyId: $stateParams.companyId,
            all: true
          }).$promise;
        }],
        categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
          return CompanyCategoryService.query({
            companyId: $stateParams.companyId,
            limit: 1000
          }).$promise;
        }]
      }
    });
  };

  $scope.changeSelectedYear = function(year) {
      $scope.selectedYear = year;
      $state.go('.', {year: year});
  };

  $scope.changeSelectedMonth = function(month) {
      $scope.selectedMonth = month;
      $state.go('.', {month: month});
  };

  $scope.filterByStatus = function(selectedPriority) {
    $scope.selectedPriority = selectedPriority;
    $state.go('.', {priorityId: (selectedPriority ? selectedPriority.id : null)});
  };
  
  $scope.pagePub = 0;
  if(publications.length >= LIMIT){
    $scope.hasMorePub = true;
  }else{
    $scope.hasMorePub = false;
  }
  
  window.onscroll = function() {
    if($scope.tabs.activeTab === 0){
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 300) {
        if($scope.hasMorePub){
          $scope.pagePub = $scope.pagePub+1;
          $scope.loadMorePublication();
          $scope.hasMorePub = false;
        }
      }
    }
  };

  $scope.loadMorePublication = function() {
    return CompanyGroupPublicationService.query({
      companyId: $stateParams.companyId, 
      groupId: $stateParams.customerPortalId, 
      year: ($stateParams.year ? $stateParams.year : null), 
      month: ($stateParams.month ? $stateParams.month : null), 
      priorityId: ($scope.selectedPriority ? $scope.selectedPriority.id : null), 
      orderby: 'created', 
      offset: $scope.pagePub*LIMIT,
      limit: LIMIT
    }).$promise.then(function(pubs){
      $scope.publications = $scope.publications.concat(pubs);
      if(pubs.length >= LIMIT){
        $scope.hasMorePub = true;
      }else{
        $scope.hasMorePub = false;
      }
    });
  };
}

CompanyCustomerPortalsDetailCtrl.resolve = {
  customerPortal: ['$stateParams', '$translate', '$q', 'CompanyGroupService', function($stateParams, $translate, $q, CompanyGroupService) {
    return CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.customerPortalId}).$promise.then(function(group) {
      if('VISIBLE' !== group.type) {
        return $q.reject($translate.instant('customer-portals.invalid'));
      }

      return group;
    });
  }],
  publications: ['$stateParams', 'CompanyGroupPublicationService', function($stateParams, CompanyGroupPublicationService) {
    return CompanyGroupPublicationService.query({
      companyId: $stateParams.companyId, 
      groupId: $stateParams.customerPortalId,
      year: ($stateParams.year ? $stateParams.year : null), 
      month: ($stateParams.month ? $stateParams.month : null), 
      priorityId: ($stateParams.priorityId ? $stateParams.priorityId : null),
      orderby: 'created', 
      offset: 0,
      limit: LIMIT
    }).$promise;
  }],
  members: ['$stateParams', 'CompanyGroupUserService', function($stateParams, CompanyGroupUserService) {
    return CompanyGroupUserService.query({
      companyId: $stateParams.companyId,
      groupId: $stateParams.customerPortalId,
      limit: 200}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'customer-portals.saved-success',
      'customer-portals.saved-failure',
      'customer-portals.removed-success',
      'customer-portals.removed-failure',
      'customer-portals.add-member-success',
      'customer-portals.add-member-failure',
      'customer-portals.remove-member-success',
      'customer-portals.remove-member-failure',
      'customer-portals.remove-publication-success',
      'customer-portals.remove-publication-failure',
      'customer-portals.invalid',
      'customer-portals.documents',
      'customer-portals.members',
      'customer-portals.info',
      'customer-portals.add-publication-success',
      'customer-portals.add-publication-failure',
      'customer-portal.template.default',
      'customer-portal.template.my-page'
    ]);
  }]
};
module.exports = CompanyCustomerPortalsDetailCtrl;

angular.module('dokiv')
  .controller('CompanyCustomerPortalsDetailCtrl', [
    '$scope',
    'customerPortal',
    'publications',
    'members',
    'translations',
    '$state',
    '$stateParams',
    '$sce',
    '$filter',
    '$modal',
    'CompanyGroupService',
    'CompanyGroupUserService',
    'CompanyGroupPublicationService',
    'CompanyPublicationService',
    'CompanyService',
    'growl',
    'priorities',
    CompanyCustomerPortalsDetailCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customer-portals/CompanyCustomerPortalsDetailCtrl.js
// module id = 329
// module chunks = 0